import React, { useContext } from "react";
import profile from "../../assets/profile.png";
import { ActiveMenuContext } from "../../contexts/MenuContext";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useAuth } from "../../contexts/AuthContext";
import UserMenu from "./UserMenu";
import { KeyboardDoubleArrowLeft } from "@mui/icons-material";

const Header = () => {
  const { activeMenu, setActiveMenu } = useContext(ActiveMenuContext);
  const { user } = useAuth();


  return (
    <div className="px-2 flex justify-between items-center w-full max-h-max border-b border-[#ccc] gap-2 h-[70px] relative">
      <div className="flex gap-2 flex-1 h-[70px] items-center">
        <button onClick={() => setActiveMenu(!activeMenu)}>
          {activeMenu ? (
            <KeyboardDoubleArrowLeft className="h-8 w-8 text-gray-500 p-1 rounded-md transition-colors duration-300 border-gray-800 bg-slate-50 hover:bg-slate-200  border -ml-[5px]" />
          ) : (
            <Bars3Icon className="h-8 w-8 text-gray-500 " />
          )}
        </button>
      </div>
      <div className="flex items-center gap-3 sm:mr-16 mr-4 relative">
        <UserMenu userName={user} img={profile} />
      </div>
    </div>
  );
};

export default Header;
